import Bot from './Bot'
export default Bot
